module.exports = __webpack_public_path__ + "media/images/mailer/person-24-white-692dd2f71782e4ef1c51021c53297af5.png";